import {writable} from 'svelte/store';

export type EmbedOptions = {
  hideProductDetails: boolean;
  displayLandingHeader: boolean;
};
export const embedOptions = writable<EmbedOptions>({
  hideProductDetails: false,
  displayLandingHeader: false,
});
